import React, { useState, useEffect } from "react";
import { getGrupos } from "../Grupo/Grupo-Api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Grid,
  DialogActions,
  ToggleButtonGroup,
  Box,
} from "@mui/material";
import { lightBlue } from "@mui/material/colors";
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import { updateActividad } from "../Actividad/Actividades-Api";

const ToggleButton = styled(MuiToggleButton)({
  margin: "10px",
  backgroundColor: "gray",
  fontWeight: "bold",
  color: "white",
  ":hover": { backgroundColor: "gray", color: "white" },
  "&.Mui-selected": { backgroundColor: "blue", color: "white" },
  "&.Mui-selected:hover": { backgroundColor: "blue", color: "white" },
});

const IaxGroupSelectorDialog = ({ open, onClose, act }) => {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState();

  useEffect(() => {
    const fetchData = () => {
      getGrupos(setItems);
      setSelectedItems(act.grupos != null ? act.grupos : []);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  // const handleToggle = (event, _newSelected) => {
  //   // setSelectedItems(newSelected);
  //   const last = _newSelected[_newSelected.length - 1];
  //   // if (selectedItems.some(i => i.id === last.id){
  //   //   selectedItems.
  //   // }

  //   // const selectedIndex = selectedItems.indexOf(last);
  //   const selectedIndex = selectedItems.map(function(e) { return e.id; }).indexOf(last.id);
  //   let newSelected = [...selectedItems];

  //   if (selectedIndex === -1) {
  //     newSelected = [...newSelected, last];
  //   } else {
  //     newSelected.splice(selectedIndex, 1);
  //   }

  //   setSelectedItems(newSelected);
  // };

  // finalmente ha sido necesario controlar el array de seleccionados desde el onclick y quitado el onchange
  const handleClick = (item) => () => {
    // const selectedIndex = selectedItems.indexOf(item);
    const selectedIndex = selectedItems
      .map(function (e) {
        return e.id;
      })
      .indexOf(item.id);
    let newSelected = [...selectedItems];

    if (selectedIndex === -1) {
      newSelected = [...newSelected, item];
    } else {
      newSelected.splice(selectedIndex, 1);
    }

    setSelectedItems(newSelected);
  };

  const handleAll = () => {
    setSelectedItems([]);
    setSelectedItems([...items]);
  }

  const handleNoOne = () => {
    setSelectedItems([]);
  }

  const handleSave = () => {
    // Aquí puedes hacer lo que quieras con los elementos seleccionados
    console.log("Elementos seleccionados:", selectedItems);
    act.grupos = selectedItems;
    updateActividad(act, onClose); // Cerrar el diálogo después de guardar los elementos seleccionados
  };

  const checkIfSelected = (item) => {
    let res = selectedItems.some((i) => i.id === item.id);
    return res;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Seleccionar grupos</DialogTitle>
      <DialogContent>
        <Grid container sx={{ width: "100%", backgroundColor: lightBlue }}>
          <ToggleButtonGroup
            value={selectedItems}
            // onChange={handleToggle}
            aria-label="Seleccionar grupos"
          >
            {items.map((item) => (
              <ToggleButton
                key={item.id}
                value={item}
                selected={checkIfSelected(item)}
                onClick={handleClick(item)}
                variant="contained"
              >
                {item.nombre}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            width: "50%",
            display: "flex",
            gap: 1,
            justifyContent: "flex-start",
          }}
        >
          <Button
            sx={{ float: "left" }}
            onClick={handleAll}
            color="success"
            variant="contained"
          >
            todos
          </Button>
          <Button
            sx={{ float: "left" }}
            onClick={handleNoOne}
            color="warning"
            variant="contained"
          >
            ninguno
          </Button>
        </Box>
        <Box
          sx={{
            width: "50%",
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
          }}
        >
          <Button onClick={onClose} color="error" variant="contained">
            Cancel.
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            autoFocus
          >
            Acept.
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default IaxGroupSelectorDialog;
